var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"rotating-icon-wrapper"},[_c('span',{staticClass:"kw kw-refresh-ccw",attrs:{"data-important-tooltip":_vm.parent.$t('refresh-state-tooltip')}})])}
var staticRenderFns = []

export { render, staticRenderFns }